import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'

function ReportSubjectGroupsTable({ data }) {

  return (
    <Table size="small"
      sx={{ marginBottom: 3, marginTop: 1, borderRadius: 3, lineHeight: 1 }}>
      <TableHead sx={{ backgroundColor: "lightgrey" }}>
        <TableRow>
          <TableCell align="left" sx={{  }}>Konu</TableCell>
          <TableCell align="left" sx={{  }}>Madde Sayısı</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item, index) => (
          <TableRow key={index}>
            <TableCell align="left" sx={{  }}>{item.subjectName}</TableCell>
            <TableCell align="left" sx={{  }}>{item.decisionCount}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default ReportSubjectGroupsTable;